import { GtmRouteDetails } from '@nx-ng/types';
import { RouteNames } from './routes';
import { environment } from '@environment';

export const SELECT_TICKET_PAGE: GtmRouteDetails = {
  page: {
    title: 'Select your ticket',
    url: RouteNames.TICKET_TYPES,
  },
  event: 'selectTicket',
};

export const TICKET_SELECTOR_PAGE: GtmRouteDetails = {
  page: {
    title: 'Ticket select',
    url: RouteNames.TICKET_SELECTOR,
  },
  event: 'ticketSelector',
};

export const RESULTS_PAGE: GtmRouteDetails = {
  page: {
    title: 'Ticket results',
    url: RouteNames.SEARCH_RESULT_TICKETS,
  },
  event: 'ticketResults',
};

export const DETAILS_PAGE: GtmRouteDetails = {
  page: {
    title: 'Your details',
    url: RouteNames.BOOKING_SUMMARY,
  },
  event: 'yourDetails',
};

export const CONFIRMATION_PAGE: GtmRouteDetails = {
  page: {
    title: 'Ticket Receipt',
    url: RouteNames.BOOKING_CONFIRMATION,
  },
  event: 'ticketReceipt',
};

export const DIRECT_DEBIT_PAGE: GtmRouteDetails = {
  page: {
    title: 'Direct Debit',
    url: RouteNames.DIRECT_DEBIT,
  },
};

export const LOGIN_EVENT: GtmRouteDetails = {
  page: {
    title: 'Login / register page',
    url: '',
  },
  event: 'loginRegister',
};

export const GTM_ROUTE_TO_EVENT_DETAILS: Record<
  RouteNames,
  GtmRouteDetails | undefined
> = {
  [RouteNames.TICKET_TYPES]: SELECT_TICKET_PAGE,
  [RouteNames.TICKET_SELECTOR]: TICKET_SELECTOR_PAGE,
  [RouteNames.SEARCH_RESULT_TICKETS]: RESULTS_PAGE,
  [RouteNames.PAYG_TICKETS]: RESULTS_PAGE,
  [RouteNames.FLEXIBLE_TICKETS]: RESULTS_PAGE,
  [RouteNames.DIRECT_DEBIT]: undefined,
  [RouteNames.CUSTOMER_DETAILS]: undefined,
  [RouteNames.BOOKING_SUMMARY]: DETAILS_PAGE,
  [RouteNames.BOOKING_CONFIRMATION]: CONFIRMATION_PAGE,
  [RouteNames.PAGE_NOT_FOUND]: undefined,
  [RouteNames.POST_LOGIN]: undefined,
  [RouteNames.PAYMENT_FAILED]: undefined,
  [RouteNames.PAYMENT_SUCCESS]: CONFIRMATION_PAGE,
};
